import { UAParser } from 'ua-parser-js';

export function generateKarrotUserAgent(
  userAgent: string = navigator.userAgent,
  appVersion: string,
  isDebug: boolean = process.env.NODE_ENV !== 'production'
): string {
  const { browser, os } = UAParser(userAgent);
  const appVersionCode = appVersion.replace(/\./g, "")?.replace(/\s/g, "");
  const osName = os.name?.replace(/\s/g, "") ?? "Unknown";
  const osVersion = os.version?.replace(/\s/g, "") ?? "0.0.0";
  const browserName = browser.name?.replace(/\s/g, "") ?? "Unknown";
  const browserVersion = browser.version?.replace(/\s/g, "") ?? "0.0.0";
  return `Web/${appVersion}/${appVersionCode} ${osName}/${osVersion}/0 ${browserName},${browserVersion}/${isDebug ? "debug" : "release"}`;
}
